import shortid from "shortid"
import * as Objdict from "objdict"

import Stage from "@frog/source/models/Stage.js"
import Step from "@frog/source/models/Step.js"
import Geometry from "@frog/source/utility/Geometry.js"
import Zone from "@frog/source/models/Zone.js"
import Reactions from "@frog/source/models/Reactions.js"
import calculateTrapPositions from "@frog/source/models/logic/calculateTrapPositions.js"

import Speedtest from "@frog/source/tests/utility/Speedtest.js"

const MAX_INFLUENCE = 200 // this is duped in Stage.js
const INFLUENCE_ITERATIONS = 4
const INFLUENCE_DECAY = 20

// const GREEDY_DIALOGUE = {
//     "captain": [
//         {
//             "text": "With this much gold, I\nthink I'll buy a new ship.",
//             "class": "captain",
//         },
//     ],
//     "recruit": [
//         {
//             "text": "This treasure will all be mine.\nI can't wait.",
//             "class": "recruit",
//         }
//     ],
//     "mercenary": [
//         {
//             "text": "This much gold would be enough\nto set me for life.",
//             "class": "mercenary",
//         }
//     ],
//     "quartermaster": [
//         {
//             "text": "All this for just some gold?\nMaybe they deserve the curse.",
//             "class": "quartermaster",
//         }
//     ],
//     "firstmate": [
//         {
//             "text": "This much gold is going to be\nheavy to hoist down the docks.",
//             "class": "firstmate",
//         }
//     ],
//     // "sharpshooter": [
//     //     {
//     //         "text": "...",
//     //         "class": "sharpshooter",
//     //     }
//     // ]
// }
// const BETRAYAL_DIALOGUE = {
//     "captain": [
//         {
//             "text": "...",
//             "class": "captain",
//         },
//     ],
//     "recruit": [
//         {
//             "text": "You bastard!",
//             "class": "recruit",
//         }
//     ],
//     "mercenary": [
//         {
//             "text": "Hey! You'll pay for this.",
//             "class": "mercenary",
//         }
//     ],
//     "quartermaster": [
//         {
//             "text": "Didn't think you had it in you.",
//             "class": "quartermaster",
//         }
//     ],
//     "firstmate": [
//         {
//             "text": "I should have seen this coming.",
//             "class": "firstmate",
//         }
//     ],
//     "sharpshooter": [
//         {
//             "text": "Ah, I guess I earned this.",
//             "class": "sharpshooter",
//         }
//     ]
// }
// const DEATH_DIALOGUE = {
//     "captain": [
//         {
//             "text": "Bah, the winds have failed me.",
//             "class": "captain",
//         },
//         {
//             "text": "This is was always how I'd go.",
//             "class": "captain",
//         },
//         {
//             "text": "Just didn't think it'd be so soon.",
//             "class": "captain",
//         },
//     ],
//     "recruit": [
//         {
//             "text": "Damn. Wasn't my day.",
//             "class": "recruit",
//         }
//     ],
//     "mercenary": [
//         {
//             "text": "Next time, I'll be rich.\nJust you wait and see.",
//             "class": "mercenary",
//         }
//     ],
//     "quartermaster": [
//         {
//             "text": "Finally.",
//             "class": "quartermaster",
//         }
//     ],
//     "firstmate": [
//         {
//             "text": "Kfh. Remember me.",
//             "class": "firstmate",
//         }
//     ],
//     "sharpshooter": [
//         {
//             "text": "Ah, I guess I earned this.",
//             "class": "sharpshooter",
//         }
//     ]
// }

const MOVE_COST = 2

import skills from "@frog/source/data/skills/skills.js"
import {getReferencedUnit} from "@frog/source/data/units.js"

import World from "@frog/source/models/World.js"

import {units} from "@frog/source/data/units.js"

const conversations = {
    "XXXXXXXXunaffiliated": {
        "captain-to-firstmate": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "Sailor!! I'm not out of it just yet.\nFall in behind me.", "class": "captain"},
                {"text": "Aye aye, captain! Does me good\nto see you walking again.", "class": "firstmate"},
            ]
        },
        "captain-to-sharpshooter": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "Avast, matie. Weapons down.", "class": "captain"},
                {"text": "C-captain! You're alive!", "class": "sharpshooter"},
                {"text": "Don't bury me yet.\nWe fight to the last man!", "class": "captain"},
                {"text": "Aye aye, captain!", "class": "sharpshooter"},
            ]
        },
        "captain-to-mercenary": {
            "changeTargetAffilationTo": "bad",
            "alsoInvokeSkill": true,
        },
        "captain-to-quartermaster": {
            "changeTargetAffilationTo": "bad",
            "alsoInvokeSkill": true,
        },

        // "firstmate-to-captain": {
        //     "changeTargetAffilationTo": "me",
        //     "dialogue": [
        //     ]
        // },
        "firstmate-to-sharpshooter": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "On me! We'll avenge the captain.", "class": "firstmate"},
                {"text": "To arms!", "class": "sharpshooter"},
            ]
        },

        "sharpshooter-to-missionary": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "If you want your freedom,\nthen give us your aid.", "class": "sharpshooter"},
                {"text": "...", "class": "missionary"},
            ]
        },

        "quartermaster-to-mercenary": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "Whatever Flint was paying\nyou, I'll double.", "class": "quartermaster"},
                {"text": "...", "class": "mercenary"},
                {"text": "I'll have it in gold.", "class": "mercenary"},
            ]
        },
        "quartermaster-to-recruit": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "Young Hawkins!! Glad to see you safe.", "class": "quartermaster"},
                {"text": "No thanks to you, sir.", "class": "recruit"},
                {"text": "You're in it now. It's too late to back out.", "class": "quartermaster"},
                {"text": "Follow me to gold and glory!", "class": "quartermaster"},
            ]
        },

        // "mercenary-to-recruit": {
        //     "changeTargetAffilationTo": "me",
        //     "dialogue": [
        //         {"text": "What are you doing here??", "class": "quartermaster"},
        //     ]
        // },

        "recruit-to-quartermaster": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "Silver, what is happening??", "class": "recruit"},
                {"text": "Young Hawkins!! Glad to see you safe.", "class": "quartermaster"},
                {"text": "No thanks to you, sir.", "class": "recruit"},
                {"text": "You're in it now. It's too late to back out.", "class": "quartermaster"},
                {"text": "Follow me to gold and glory!", "class": "quartermaster"},
            ]
        },
        "recruit-to-mercenary": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "You oaf! I've been looking for you all over!!", "class": "recruit"},
                {"text": "What're you doing here??\nDoes mom know you're here?", "class": "quartermaster"},
                {"text": "She'll know I got you home.\nWe're going to make it through this.", "class": "recruit"},
                {"text": "Together.", "class": "recruit"},
            ]
        },

        "captain-to-bard": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "Who are you? What're you\ndoing on my ship?", "class": "captain"},
                {"text": "I am but a humble traveler.", "class": "bard"},
                {"text": "A stowaway.", "class": "captain"},
                {"text": "And for this fight, your support!", "class": "bard"},
                {"text": "Just don't get in the way.", "class": "captain"},
            ]
        },
        "firstmate-to-bard": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "Be you friend of silver or flint?", "class": "firstmate"},
                {"text": "I am friend to none.", "class": "bard"},
                {"text": "That's enough for me.", "class": "firstmate"},
            ]
        },
        // "sharpshooter-to-bard": {
        //     "changeTargetAffilationTo": "me",
        //     "dialogue": [
        //         {"text": "I remember you! You're the spoony\nbard from back in Tortuga.", "class": "sharpshooter"},
        //         {"text": "And once this fight is done, you'll\nremember me forever!", "class": "bard"},
        //         {"text": "I'll drink to that. Play me a tune!", "class": "sharpshooter"},
        //     ]
        // },
        "quartermaster-to-bard": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "Not sure how you got here, but\nI don't want any trouble.", "class": "quartermaster"},
                {"text": "At ease, just here for fun.", "class": "bard"},
                {"text": "Will you sing me a song? Like the old days.", "class": "quartermaster"},
                {"text": "I wouldn't mind.", "class": "bard"},
            ]
        },
        "mercenary-to-bard": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "No blade, no gun. You here to die?", "class": "mercenary"},
                {"text": "Not just yet.", "class": "bard"},
                {"text": "Join us, or I slit your throat here.", "class": "mercenary"},
                {"text": "Good enough for me.", "class": "bard"},
            ]
        },
        "recruit-to-bard": {
            "changeTargetAffilationTo": "me",
            "dialogue": [
                {"text": "I've no time for a fool.", "class": "recruit"},
                {"text": "There never is.", "class": "bard"},
                {"text": "Sing for me, and I'll tip double.", "class": "recruit"},
            ]
        },
        // "missionary-to-bard": {
        //     "changeTargetAffilationTo": "me",
        //     "dialogue": [
        //         {"text": "...", "class": "missionary"},
        //         {"text": "...", "class": "bard"},
        //     ]
        // },
    }
}
function getConversation(action) {
    const target = Stage.findUnitByPosition(action.omegastage, action.position)
    const performer = action.omegastage.units[action.performerKey]

    if(target == undefined) {
        return undefined
    }

    if(target.affiliation != performer.affiliation) {
        if(conversations["unaffiliated"] != undefined
        && conversations["unaffiliated"][performer.class + "-to-" + target.class] != undefined) {
            return conversations["unaffiliated"][performer.class + "-to-" + target.class]
        }
    }

    return {
        "alsoInvokeSkill": true
    }
}

export default class Unit {
    static instantiate({unit, player, chapterParty}) {
        let partyUnit = {}
        let chapterPartyUnit = {}
        if(player != undefined
        && player.party.units != undefined
        && player.party.units[unit.key] != undefined) {
            partyUnit = player.party.units[unit.key]
        }
        if(chapterParty != undefined
        && chapterParty.units != undefined
        && chapterParty.units[unit.key] != undefined) {
            chapterPartyUnit = chapterParty.units[unit.key]
        }
        let firstMergedUnit = Objdict.merge(unit, partyUnit, chapterPartyUnit)

        let referenceUnit = getReferencedUnit(firstMergedUnit)
        // if(firstMergedUnit.skills instanceof Array == false) {
        //     firstMergedUnit.skills = [firstMergedUnit.skills]
        // }
        const baseUnit = {
            "key": shortid.generate(),
            "energy": {"move": true, "invoke skill": true},
            "inventory": {"count": 1},
            "effects": {},
            "skills": [],
            "equippedSkills": {},
            "position": {"x": 0, "y": 0},
            // "state": "aggroed",
        }

        delete firstMergedUnit.actionmap // we do not instantiate action maps!!!
        const mergedUnit = Objdict.merge(baseUnit, referenceUnit, firstMergedUnit)

        mergedUnit.maxhealth = mergedUnit.maxhealth ?? 0
        mergedUnit.maxarmor = mergedUnit.maxarmor ?? 0
        if(mergedUnit.health === undefined) {
            mergedUnit.health = mergedUnit.maxhealth
        }
        if(mergedUnit.armor === undefined
        && mergedUnit.maxarmor !== undefined) {
            mergedUnit.armor = mergedUnit.maxarmor
        }

        // if(mergedUnit.position == undefined) {
        //     throw new Error("Unit.instantiate needs position")
        // }
        if(mergedUnit.skills == undefined) {
            throw new Error("Unit.instantiate needs skills")
        }
        if(mergedUnit.equippedSkills == undefined) {
            throw new Error("Unit.instantiate needs skills")
        }
        // if(mergedUnit.images == undefined) {
        //     throw new Error("Unit.instantiate needs images")
        // }

        // if(mergedUnit.unlockedSkills != undefined) {
        //     mergedUnit.skills = mergedUnit.skills.concat(mergedUnit.unlockedSkills)
        //     delete mergedUnit.unlockedSkills
        // }

        return mergedUnit
    }
    static computeInfluenceMap(affiliation, stage, position) {
        let influence = {}

        Objdict.forEach(stage.units, (unit) => {
            if(unit.affiliation != affiliation
            && unit.affiliation != "none"
            && unit.type != "zone"
            && unit.isDead != true
            && unit.hasBeenRemoved != true) {
                influence[unit.position.x + "x" + unit.position.y] = MAX_INFLUENCE
            }
        })

        for(let i = 0; i < INFLUENCE_ITERATIONS; i += 1) {
            let nextInfluence = {}
            const INFLUENCE_ZONE = stage.encounters[stage.currentEncounter || 1].zone || {}
            for(let x = INFLUENCE_ZONE.x; x <= INFLUENCE_ZONE.x + INFLUENCE_ZONE.width; x += 1) {
                for(let y = INFLUENCE_ZONE.y; y <= INFLUENCE_ZONE.y + INFLUENCE_ZONE.height; y += 1) {
                    const terrain = stage.world.terrain[x + "x" + y]
                    if(terrain == undefined) continue
                    const z = terrain.position.z + terrain.size.z

                    const position = {x, y, z}
                    nextInfluence[position.x + "x" + position.y] = influence[position.x + "x" + position.y] || 0
                    Geometry.getNeighborPoints(position).forEach((nextPosition) => {
                        const collision = Stage.findCollision({
                            "stage": stage,
                            "previousPosition": position,
                            "nextPosition": nextPosition
                        })

                        if(collision != undefined) {
                            if(collision.type == "world") return
                        }
                        const value = (influence[nextPosition.x + "x" + nextPosition.y] || 0) - INFLUENCE_DECAY
                        if(nextInfluence[position.x + "x" + position.y] < value) {
                            nextInfluence[position.x + "x" + position.y] = value
                        }
                    })
                }
            }
            influence = nextInfluence
        }

        return influence
    }

    // This function will return an actionmap, a
    // hash of all the possible actions the given
    // unit could perform within range. An "action"
    // can be a move, an attack, an assist, etc.
    static calculateActions(performerKey, stage) {
        const mark = Speedtest.mark("Actions", "Unit.calculateActions")

        if(stage == undefined) throw new Error("requires action.stage")
        if(performerKey == undefined) throw new Error("requires action.performerKey")

        const startingAction =  {}

        const performer = stage.units[performerKey]
        if(performer == undefined) {
            throw new Error("Could not find unit " + performerKey + " in the stage.")
        }

        if(performer.isDead) {
            return
        }

        startingAction.performerKey = performerKey
        startingAction.isStartingAction = true
        startingAction.type = performer.energy["move"] == true ? "wait-for-move" : "wait-for-attack"
        startingAction.position = performer.position
        startingAction.alphastage = startingAction.omegastage = Stage.copy(stage)
        startingAction.distance = performer.energy["move"] == true ? 0 : performer.moverange
        startingAction.steps = []

        const submark = Speedtest.mark("Unit.calculateAction", "influence map")
        startingAction.influenceMap = Unit.computeInfluenceMap(performer.affiliation, startingAction.alphastage, performer.position)
        submark()

        const actionmap = {}

        Unit.populateActionMap(actionmap, startingAction)
        Unit.pruneInternalActionMapData(actionmap)

        mark()
        return actionmap
    }
    static populateActionMap(actionmap, stubAction) {
        const calculatedAction = Unit.calculateAction(stubAction)
        if(calculatedAction == undefined) return
        Unit.saveAction(actionmap, calculatedAction)
        if(calculatedAction.nextActions != undefined) {
            calculatedAction.nextActions.forEach((nextAction) => {
                Unit.populateActionMap(actionmap, nextAction)
            })
        }
    }
    static calculateAction(action) {
        const mark1 = Speedtest.mark("Unit.calculateAction", "initialization")

        if(action.type === undefined) throw new Error("requires action.type")
        if(action.position === undefined) throw new Error("requires action.position")
        if(action.performerKey === undefined) throw new Error("requires action.performerKey")
        if(action.alphastage === undefined) throw new Error("requires action.alphastage")

        action.alphastage = Stage.copy(action.alphastage)

        // If nothing else happens, the omegastage
        // will match the alphastage. But throughout
        // this action, the omegastage will be cloned
        // and edited via the game logic.
        action.omegastage = action.alphastage

        action.positions = [
            {"x": action.position.x, "y": action.position.y, "z": action.position.z, "type": action.type}
        ]
        action.steps = []

        if(action.previousAction != undefined) {
            action.positions = action.positions.concat(action.previousAction.positions)

            // TODO: we really reusing these and not recomputing these?
            action.steps = action.steps.concat(action.previousAction.steps.filter((step) => {
                return step.type != "exhaust energy"
                    && step.type != "increment stage.actionMark"
                    && step.type != "recalculate light"
            }))
            // if(action.steps.length > 0) {
            //     action.omegastage = action.steps[action.steps.length-1].omegastage
            // }
            // TODO: YOU REALLY CAN't JUST FILTER THE STEPS AND NOT ASSUME THE OMEGASTAGE
            // IS ALSO FILTERED; IT WAS BUIlT ON EACH OF THOSE STEPS IN TURN, SO IT IS
            // STILL TRUE EVEN IF YOU REMOVE THE STEPS!!
        }

        mark1()

        ///////////////////////////////
        // Unit-to-World Collision  //
        /////////////////////////////

        const mark2 = Speedtest.mark("Unit.calculateAction", "unit-to-world collision")

        const previousPosition = action.positions[1] || action.position
        const nextPosition = action.positions[0] || action.position

        if(action.type == "invoke skill") {
            if(World.isOutOfBounds(action.alphastage.world, nextPosition)) {
                mark2()
                return
            }
            if(Zone.isOutOfBounds(action.alphastage.encounters[action.alphastage.currentEncounter || 1].zone, nextPosition)) {
                mark2()
                return
            }
            const skill = skills.get(action.skillKey)
            if(skill == undefined) {
                mark2()
                return
            }

            if(skill.range.type != "arc") {
                if(World.hasCollision2({
                    "world": action.alphastage.world,
                    previousPosition, nextPosition,
                    "zone": action.alphastage.encounters[action.alphastage.currentEncounter || 1].zone,
                })) {
                    mark2()
                    return
                }

                // const previousTerrain = World.getTerrain(action.alphastage.world, previousPosition)
                // const nextTerrain = World.getTerrain(action.alphastage.world, nextPosition)
                // const zDistance = Math.abs((previousTerrain.position.z + previousTerrain.size.z) - (nextTerrain.position.z + nextTerrain.size.z))
                // // Let units move between blocks if there is only
                // // a half-block delta! (ramps are considered half-blocks)
                // const MOVEMENT_SIZE = 1
                // if(zDistance <= MOVEMENT_SIZE) {
                //     action.position.z = nextTerrain.position.z + nextTerrain.size.z
                // }
            }

            // if(skill.range.type == "arc") {
            //     const nextTerrain = World.getTerrain(action.alphastage.world, nextPosition)
            //     if(nextTerrain != undefined) {
            //         // if(nextTerrain.shape == "obstruction") {
            //         //     mark2()
            //         //     return
            //         // }
            //         action.position.z = nextTerrain.position.z + nextTerrain.size.z
            //     }
            // }
        }

        if(action.type == "move") {
            const alphaperformer = action.alphastage.units[action.performerKey]
            if(alphaperformer.movetype == "flying") {
                if(World.isOutOfBounds(action.alphastage.world, nextPosition)) {
                    mark2()
                    return
                }
            } else {
                if(World.hasCollision2({
                    "world": action.alphastage.world,
                    previousPosition, nextPosition,
                    "zone": action.alphastage.encounters[action.alphastage.currentEncounter || 1].zone,
                })) {
                    mark2()
                    return
                }

                if(action.distance > 0) {
                    const nextTerrain = World.getTerrain(action.alphastage.world, nextPosition)
                    if(nextTerrain != undefined
                    && nextTerrain.isTree == true) {
                        if(alphaperformer.movetype == "mounted") {
                            mark2()
                            return
                        }
                        if(action.distance > MOVE_COST) {
                            mark2()
                            return
                        }
                        action.distance += MOVE_COST * 3
                    }
                }
            }
        }

        mark2()

        /////////////////////////////
        // Unit-to-Unit Collision //
        ///////////////////////////

        const mark3 = Speedtest.mark("Unit.calculateAction", "unit-to-unit collision")

        if(action.type == "move") {
            const performer = action.alphastage.units[action.performerKey]
            // Scan for any units at this position.
            const units = Stage.findUnitsByPosition(action.alphastage, action.position, {"excludeUnitKey": action.performerKey, "includingZones": true})
            const canMoveHere = units.every((unit) => {
                if(unit.type == "zone") {
                    return true
                    // return unit.canWalkOntoTheZone
                }

                if(unit.affiliation == performer.affiliation
                && unit.effects.flinch == undefined) {
                    action.type = "move through"
                    return true
                }
                return false
            })

            if(canMoveHere == false) {
                action.type == "no move"
                mark3()
                return
            }
        }

        if(action.type == "invoke skill"
        && skills.get(action.skillKey).canTarget instanceof Function
        && skills.get(action.skillKey).canTarget({
            "performerKey": action.performerKey,
            "stage": action.alphastage,
            "position": action.position,
        }) == false) {
            action.type == "no invoke skill can not target"
            mark3()
            return
        }

        mark3()

        ///////////////////////////////
        // Calculate the Omegastage //
        /////////////////////////////

        const mark4 = Speedtest.mark("Unit.calculateAction", "omegastage calculation")

        if(action.type == "wait-for-move") {
            addStep(action, Step.instantiate({
                "type": "exhaust energy",
                "alphastage": action.omegastage,
                "deltastages": [
                    {
                        "units": {
                            [action.performerKey]: {
                                "energy": {"move": false}
                            }
                        }
                    },
                ]
            }))
        }

        if(action.type == "move"
        || action.type == "move through") {
            if(action.direction != undefined) {
                addStep(action, Step.instantiate({
                    "type": "turn",
                    "alphastage": action.omegastage,
                    "deltastages": [
                        {
                            "unit": {
                                "key": action.performerKey,
                                "direction": action.direction,
                            }
                        }
                    ]
                }))
            }
            const performer = action.omegastage.units[action.performerKey]
            addStep(action, Step.instantiate({
                // "type": performer.affiliation != "good" ? "move" : "move-without-animation",
                "type": "move",
                "affiliation": performer.affiliation, // DEBUG
                "alphastage": action.omegastage,
                "deltastages": [
                    {
                        "annotation": {
                            "unitReference": performer.reference,
                            "unitKey": performer.key,
                        },
                        "units": {
                            [action.performerKey]: {
                                "position": {
                                    "mode": "absolute",
                                    "x": action.position.x,
                                    "y": action.position.y,
                                    "z": action.position.z,
                                },
                            }
                        }
                    }
                ]
            }))

            addStep(action, Reactions.getSteps(action.omegastage))

            // TODO! Move this into the reactions up above?
            checkForTrapsAtUnitPosition(action, action.performerKey)

            // TODO: why is there logic aroundthis? of course we exhaust the energy!!
            // const omegaperformer = action.omegastage.units.find((unit) => unit.key == action.performerKey)
            if(action.type == "move") {
            // && action.distance >= omegaperformer.moverange
            // && omegaperformer.energy.move != true) {
                addStep(action, Step.instantiate({
                    "type": "exhaust energy",
                    "alphastage": action.omegastage,
                    "deltastages": [
                        {
                            "units": {
                                [action.performerKey]: {
                                    "energy": {"move": false}
                                }
                            }
                        },
                    ]
                }))
            }
        }


        if(action.type == "invoke skill"
        && action.skillKey != undefined) {
            if(action.direction != undefined) {
                addStep(action, Step.instantiate({
                    "type": "turn",
                    "alphastage": action.omegastage,
                    "deltastages": [
                        {
                            "unit": {
                                "key": action.performerKey,
                                "direction": action.direction,
                            }
                        }
                    ]
                }))
            }
            // const performer = action.omegastage.units[action.performerKey]
            // const target = Stage.findUnitAtPosition(action.omegastage, action.position)
            // if(target != undefined) {
            //     action.targetAffiliation = target.affiliation
            // }
            //
            //
            // // CONVO // DEBUG
            // const conversation = getConversation(action)
            //
            // if(conversation != undefined
            // && conversation.dialogue != undefined) {
            //     conversation.dialogue.forEach((dialogue) => {
            //         addStep(action, Step.instantiate({
            //             "type": "say",
            //             "alphastage": action.omegastage,
            //
            //             "deltastages": [
            //                 {
            //                     "mark": 0,
            //                     "dialogue": {
            //                         "text": dialogue.text,
            //                         "portrait": dialogue.portrait,
            //                     }
            //                 }
            //             ],
            //             "isImportant": true,
            //             "duration": Infinity,
            //         }))
            //     })
            //     addStep(action, Step.instantiate({
            //         "type": "unsay",
            //         "alphastage": action.omegastage,
            //         "deltastages": [
            //             {
            //                 "mark": 0,
            //                 "dialogue": null
            //             }
            //         ],
            //     }))
            // }
            //
            // if(conversation != undefined
            // && conversation.changeTargetAffilationTo != undefined) {
            //     addStep(action, Step.instantiate({
            //         "alphastage": action.omegastage,
            //         "deltastages": [
            //             {
            //                 "mark": 0,
            //                 "unit": {
            //                     "key": target.key,
            //                     "affiliation": conversation.changeTargetAffilationTo == "me" ? action.alphastage.units[action.performerKey].affiliation : conversation.changeTargetAffilationTo,
            //                 }
            //             }
            //         ],
            //     }))
            // }
            //
            // if(conversation == undefined
            // || conversation.type == "invoke skill"
            // || conversation.alsoInvokeSkill == true) {
            const skill = skills.get(action.skillKey)
            if(skill.calculateStep instanceof Function) {
                const step = skill.calculateStep({
                    "performerKey": action.performerKey,
                    "position": action.position,
                    "stage": action.omegastage,
                })
                addStep(action, step)
                if(step.followupSteps != undefined) {
                    step.followupSteps.forEach((followupStep) => {
                        addStep(action, followupStep)
                        // TODO: Do we have any gaurentee that these
                        // followup steps are respecting the invoke skill step.omegastage?
                        // and that we can use it without killing and undoing the invoke skill?
                    })
                }
            } else {
                // TODO: Deprecate this!!
                addStep(action, Step.instantiate({
                    "type": "invoke skill",
                    "skillKey": action.skillKey,
                    "alphastage": action.omegastage,
                    "deltastages": skill.calculateDeltastages({
                        "performerKey": action.performerKey,
                        "position": action.position,
                        "stage": action.omegastage,
                    }),
                }))
            }

            // if(action.position.x == 7 && action.position.y == 4
            // || action.position.x == 8 && action.position.y == 2
            // || action.position.x == 10 && action.position.y == 3) {
            //     const performer = action.omegastage.units[action.performerKey]
            //     if(performer.affiliation == "good"
            //     && GREEDY_DIALOGUE[performer.class] != undefined) {
            //         GREEDY_DIALOGUE[performer.class].forEach((dialogue) => {
            //             addStep(action, Step.instantiate({
            //                 "type": "say",
            //                 "alphastage": action.omegastage,
            //
            //                 "deltastages": [
            //                     {
            //                         "mark": 0,
            //                         "dialogue": dialogue
            //                     }
            //                 ],
            //                 "isImportant": true,
            //                 "duration": Infinity,
            //             }))
            //         })
            //         addStep(action, Step.instantiate({
            //             "type": "unsay",
            //             "alphastage": action.omegastage,
            //             "deltastages": [
            //                 {
            //                     "mark": 0,
            //                     "dialogue": null
            //                 }
            //             ],
            //         }))
            //     }
            // }

            /////////////
            // DEATHS //
            ///////////
            addStep(action, Reactions.getSteps(action.omegastage))

            // BETRAYAL_DIALOGUE //

            // const target = Stage.findUnitAtPosition(action.alphastage, action.position)
            // if(target != undefined) {
            //     const alphaunit = action.alphastage.units[target.key]
            //     const omegaunit = action.omegastage.units[target.key]
            //     if(alphaunit != undefined
            //     && omegaunit != undefined
            //     && alphaunit.affiliation != omegaunit.affiliation
            //     && omegaunit.isDead != true) {
            //         if(BETRAYAL_DIALOGUE[unit.class] != undefined) {
            //             BETRAYAL_DIALOGUE[unit.class].forEach((dialogue) => {
            //                 addStep(action, Step.instantiate({
            //                     "type": "say",
            //                     "alphastage": action.omegastage,
            //
            //                     "deltastages": [
            //                         {
            //                             "mark": 0,
            //                             "dialogue": dialogue
            //                         }
            //                     ],
            //                     "isImportant": true,
            //                     "duration": Infinity,
            //                 }))
            //             })
            //             addStep(action, Step.instantiate({
            //                 "type": "unsay",
            //                 "alphastage": action.omegastage,
            //                 "deltastages": [
            //                     {
            //                         "mark": 0,
            //                         "dialogue": null
            //                     }
            //                 ],
            //             }))
            //         }
            //     }
            // }

            //////////////////////
            // COUNTER-ATTACKS //
            ////////////////////

            if(skills.get(action.skillKey).class == "attack") {
                const targetedUnit = Stage.findUnitAtPosition(action.alphastage, action.position)
                if(targetedUnit != undefined
                && action.omegastage.units[targetedUnit.key] != undefined
                && action.omegastage.units[targetedUnit.key].isDead != true) {
                    const target = action.omegastage.units[targetedUnit.key]
                    const performer = action.omegastage.units[action.performerKey]
                    const counterattackSkillKey = Objdict.find(target.equippedSkills, (skillKey) => {
                        return (skills.get(skillKey).type == "counterattack" || skills.get(skillKey).canCounterattack)
                            && Geometry.isWithinRange(target.position, performer.position, skills.get(skillKey).range) // DOES NOT RESPECT Z
                            // If you ever want this to be a "on damage" rather than a fire-emblem-style counterattack
                            // then remove this Geometry.isWithinRange condition.
                    })
                    // const vector = Geometry.difference(performer.position, target.position)
                    // const direction = {"x": 0, "y": 0}
                    // if(vector.x == 0 && vector.y != 0) {
                    //     direction.y = Math.sign(vector.y)
                    // } else if(vector.x != 0 && vector.y == 0) {
                    //     direction.x = Math.sign(vector.x)
                    // } else if(vector.x != 0 && vector.y != 0) {
                    //     if(Math.abs(vector.x) > Math.abs(vector.y)) {
                    //         direction.x = Math.sign(vector.x)
                    //     } else {
                    //         direction.y = Math.sign(vector.y)
                    //     }
                    // }
                    // TODO: read a direction from the deltaunit, so the skills can define
                    // the direction of damage instead of this ungrokable math equation.
                    // const position = Geometry.add(target.position, direction)
                    if(counterattackSkillKey != undefined) {
                        const skill = skills.get(counterattackSkillKey)
                        if(skill.calculateStep instanceof Function) {
                            const step = skill.calculateStep({
                                "performerKey": target.key,
                                "position": performer.position,
                                "stage": action.omegastage,
                            })
                            addStep(action, step)
                        } else {
                            // TODO: Deprecate this!!
                            addStep(action, Step.instantiate({
                                "type": "invoke skill",
                                "alphastage": action.omegastage,
                                "deltastages": skill.calculateDeltastages({
                                    "performerKey": target.key,
                                    "position": performer.position,
                                    "stage": action.omegastage,
                                }),
                            }))
                        }
                    }
                }

                /////////////
                // DEATHS //
                ///////////
                addStep(action, Reactions.getSteps(action.omegastage))
            }

            // TRAPS TRIGGERED BY UNITS BEING PUSHED //
            // TODO: this could be A REACTIVE SYSTEM, AUTOMATICALLY TRIGGERED WHEN THIS SORT OF STATE CHANGES
            action.steps[action.steps.length - 1].deltastages.forEach((deltastage) => {
                if(deltastage?.unit?.position == undefined) return
                checkForTrapsAtUnitPosition(action, deltastage.unit.key)
                // Objdict.forEach(deltastage.units, (deltaunit, unitKey) => {
                //     if(deltaunit.position == undefined) return
                //     checkForTrapsAtUnitPosition(action, unitKey)
                // })
            })

            /////////////
            // ENERGY //
            ///////////
            addStep(action, Step.instantiate({
                "type": "exhaust energy",
                "alphastage": action.omegastage,
                "deltastages": [
                    {
                        "units": {
                            [action.performerKey]: {
                                "energy": {"invoke skill": false}
                                // "energy": {"move": false, "invoke skill": false}
                            }
                        }
                    },
                ]
            }))
        }

        // const light = "hello world"
        // addStep(action, Step.instantiate({
        //     "type": "recalculate light",
        //     "alphastage": action.omegastage,
        //     "deltastages": [
        //         {
        //             "light": light
        //         }
        //     ]
        // }))

        // addStep(action, Step.instantiate({
        //     "type": "increment stage.actionMark",
        //     "alphastage": action.omegastage,
        //     "deltastages": [{"actionMark": (action.omegastage.actionMark || 0) + 1}]
        // }))

        // /////////////////////
        // // Passive Skills //
        // ///////////////////
        // // NONE OF THESE RESPECT .SKILLKEY (OVER .SKILL)
        // Speedtest.point("apply passives")
        //
        // action.alphastage.units.forEach((shadowunit) => {
        //     if(shadowunit.skills != undefined) {
        //         shadowunit.skills.forEach((skill) => {
        //             if(skill.type == "passive"
        //             && skill.trigger == "reaction") {
        //                 skill.editResults(action, shadowunit)
        //             }
        //         })
        //     }
        // })

        // //////////////////////
        // // Counter-Attacks //
        // ////////////////////
        // // NONE OF THESE RESPECT .SKILLKEY (OVER .SKILL)
        // // DON'T WE ALREADY HAVE THIS UP ABOVE?
        /// /// DOES NOT RESPECT ACTION.PERFORMERKEY
        // Speedtest.point("predict counter-attacks")
        //
        // if(action.type === "invoke"
        // && action.skill.canBeCountered != true
        // && action.alphastage.units.target.health + ((action.results && action.results.target && action.results.target.health) || 0) > 0) {
        //     let counterskill = action.target.skills.find((skill) => {
        //         return skill.type == "counterattack"
        //             && skill.canTarget(action.performer, action.target, action, action.stage)
        //     })
        //     if(!!counterskill) {
        //         action.counterAction = {
        //             "type": "invoke",
        //             "skill": counterskill,
        //             "target": action.performer,
        //             "performer": action.target,
        //             "results": counterskill.calculateDeltastages(action.performer, action.target, true /*isCounterAction*/, {"units": action.alphastage.units}, action)
        //         }
        //     }
        // }
        //
        // // // TODO: also shadow the counter actions
        // // if(action.counterAction != undefined) {
        // //     if(action.counterAction.results != undefined
        // //     && action.counterAction.results.target != undefined
        // //     && action.counterAction.results.target.health != undefined) {
        // //         shadowunit.health += action.counterAction.results.target.health
        // //     }
        // //     // TODO: am i reading this right? we only predict target health for
        // //     // counteractions. no performer health, no target position.
        // // }

        // TODO: Aggregate all the step results into a common result object.

        // // TODO: Revisit calculating the FUTURE state of next turn if the
        // // players chose to end their turn right after this action, mostly
        // // including end-of-turn effects.
        // startTurnEffects.forEach((effect) => {
        //     const results = effect.calculateDeltastages({
        //         "previousState": action.quantumstate["turn:=0"]
        //     })
        //     Object.keys(results).forEach((key) => {
        //         const result = results[key]
        //         const unit = action.quantumstate["turn:+1:start"].units.find((unit) => unit.key == key)
        //         if(unit != undefined) {
        //             unit.health += result.health
        //             unit.isDead = unit.health <= 0
        //         }
        //     })
        // })
        // action.quantumstate["turn:+1:start"] = {
        //     // "units": action.shadowunits.map((unit) => {
        //     //     return {
        //     //         "key": unit.key,
        //     //         "delta": {"health": 0},
        //     //         "alpha": clonedeep(unit),
        //     //         "omega": {/*to be computed*/}
        //     //     }
        //     // }),
        //     "tiles": clonedeep(action.shadowtiles),
        //     "units": clonedeep(action.shadowunits),
        // }
        mark4()

        ///////////////////
        // FLOW ACTIONS //
        /////////////////

        // This is where we flow to all the neighboring
        // tiles. These checks do not verify whether the
        // unit can move to this tile or act on this tile,
        // but it does propagate the actions to check.

        action.nextActions = []

        const mark7 = Speedtest.mark("Unit.flowActions", "flow: move")
        const omegaperformer = action.omegastage.units[action.performerKey]
        if(action.type == "move"
        || action.type == "wait-for-move"
        || action.type == "move through") {
            if(omegaperformer.isDead != true
            // && omegaperformer.state != "idle"
            // && omegaperformer.energy["move"] == true
            && action.distance < omegaperformer.moverange
            && Unit.isFlinching(omegaperformer) == false) {
                Geometry.getNeighborPoints(action.position).forEach((neighborposition) => {
                    if(action.positions.find((previousPosition) => Geometry.equals(previousPosition, neighborposition))) {
                        return
                    }
                    const nextTerrain = World.getTerrain(action.alphastage.world, neighborposition)
                    if(nextTerrain == undefined) return // TODO: SHOULD WE REALLY BE DOING THE WORLD COLLISION CHECK HERE?
                    let distance = MOVE_COST
                    if(nextTerrain.isPath) distance = MOVE_COST / 2
                    // if(nextTerrain.isTree) distance = MOVE_COST * 2
                    if(action.distance + distance > omegaperformer.moverange) return
                    action.nextActions.push({
                        "type": "move",
                        "performerKey": action.performerKey,
                        "position": neighborposition,
                        "distance": action.distance + distance,
                        "alphastage": action.omegastage,
                        "previousAction": action, // used for steps and positions
                        "influenceMap": action.influenceMap,
                        "direction": Geometry.direction(neighborposition, action.position),
                    })
                })
            }
        }
        mark7()

        const mark8 = Speedtest.mark("Unit.flowActions", "flow: invoke skill")
        if(action.type == "move"
        || action.type == "wait-for-move"
        || action.type == "wait-for-attack") {
            if(omegaperformer.isDead != true
            && omegaperformer.energy["invoke skill"] == true
            && omegaperformer.equippedSkills != undefined) {
            // && Unit.isFlinching(omegaperformer) == false) {
                const skillsToInvoke = ["support1", "attack1", "attack2", "attack3", "attack4", "attack5"]
                skillsToInvoke.forEach((skillSlot) => {
                    const skillKey = omegaperformer.equippedSkills[skillSlot]
                    if(skillKey == undefined
                    || skills.get(skillKey) == undefined) {
                        return
                    }
                    const skill = skills.get(skillKey)
                    if(skill.type == "invoke") {

                        let positions = []
                        if(skill.range.type == "findCollisionInDirection") {
                            Object.values(Geometry.orthodirections).forEach((direction) => {
                                positions = positions.concat(Stage.findCollisionInDirection({
                                    "stage": action.omegastage,
                                    "position": omegaperformer.position,
                                    "direction": direction,
                                    "maxdistance": skill.range.max,
                                    "options": skill.range.options,
                                }).positions)
                            })
                        } else {
                            positions = Geometry.getNeighborPoints(action.position, skill.range)
                        }

                        positions.forEach((position) => {
                            action.nextActions.push({
                                "type": "invoke skill",
                                "skillKey": skillKey,
                                "performerKey": action.performerKey,
                                "position": position,
                                "alphastage": action.omegastage,
                                "previousAction": action, // used for steps and positions
                                "influenceMap": action.influenceMap,
                                "direction": Geometry.direction(position, action.position),
                            })
                        })
                    }
                })
            }
        }
        mark8()

        return action
    }
    static saveAction(actionmap, action) {
        const mark = Speedtest.mark("Unit.calculateAction", "save the action")

        // What makes each action different, even if they share a position and performer?
        // distance is NOT the same
        // skill + type is NOT the same
        // prev actions are NOT the same
        // (probably more, now. this list is very old)

        action.key = action.type + ":" + action.positions.map(Geometry.toString).reverse().join(">")

        const positionkey = action.position.x + "x" + action.position.y // + "x" + action.position.z // DEBUG DID A BAD THING HUH
        actionmap[positionkey] = actionmap[positionkey] || []
        actionmap[positionkey].push(action)

        mark()
        return actionmap
    }
    static pruneInternalActionMapData(actionmap) {
        Objdict.forEach(actionmap, (actionmaptile) => {
            actionmaptile.forEach((action) => {
                // delete action.distance
                delete action.previousAction
                delete action.nextActions
                delete action.isStartingAction
                // delete action.influenceMap
                // performerKey
                // skillKey
                // type
                // steps
                // omegastage
                // alphastage
                // positions
                // position
            })
        })
        return actionmap
    }

    static copy(unit) {
        if(unit == undefined) return undefined
        return {
            "key": unit.key, // unit's individual unique key
            "reference": unit.reference, // unit's shared base class key
            "isDead": unit.isDead || false,
            "hasBeenRemoved": unit.hasBeenRemoved, // todo: THIS IS VICTORY CONDITION SPECIFIC
            "position": unit.position && {
                "x": unit.position.x,
                "y": unit.position.y,
                "z": unit.position.z,
            },
            "affiliation": unit.affiliation,
            "skills": unit.skills,
            "equippedSkills": unit.equippedSkills,
            // "unlockedSkills": unit.unlockedSkills,
            // "unlockableSkills": unit.unlockableSkills,
            "energy": {
                "move": unit.energy && unit.energy["move"],
                "invoke skill": unit.energy && unit.energy["invoke skill"],
            },
            "element": unit.element,
            "health": unit.health,
            "power": unit.power,
            "maxhealth": unit.maxhealth,
            "moverange": unit.moverange,
            "movetype": unit.movetype,
            "image": unit.image,
            "portrait": unit.portrait,
            "portrait_hidden": unit.portrait_hidden,
            "images": unit.images,
            "sounds": unit.sounds,
            "effects": Objdict.map(unit.effects, (effect) => {
                const reeffect = {
                    "type": effect.type,
                    "timer": effect.timer,
                }
                for(let key in effect) {
                    if(effect[key] != undefined) {
                        reeffect[key] = effect[key]
                    }
                }
                // if(effect["range"] !== undefined) reeffect["range"] = effect["range"] // TODO: make this a deeper copy, not a shallow copy
                // if(effect["actionMark"] !== undefined) reeffect["actionMark"] = effect["actionMark"]
                // if(effect["skillKey"] !== undefined) reeffect["skillKey"] = effect["skillKey"]
                // if(effect["positions"] !== undefined) reeffect["positions"] = effect["positions"]
                // // WE HAVE TO DO THIS TO SATISFY DUMB TEST COMPARES
                return reeffect
            }),
            "name": unit.name,
            // "number": unit.number, // THESE ARE STATIC DECORATOR META VALUES, WHICH WE
            // SHOULD SOMEDAY BE ABLE TO JUST READ FROM A REFERENCED PROTOTYPE PARENT.
            // "family": unit.family,
            // "inventory": {
            //     "count": unit.inventory.count
            // },
            "experience": unit.experience,
            "armor": unit.armor,
            "maxarmor": unit.maxarmor,
            "armortype": unit.armortype,
            "level": unit.level,
            "className": unit.className,
            "classname": unit.classname,
            "state": unit.state,
            "class": unit.class,
            "type": unit.type,
            "score": unit.score,
            "isVisible": unit.isVisible,
            "disableHealth": unit.disableHealth, // YIKES I WISH WE JUST DIDN'T ADD HEALTH TO BEGIN WITH (WITHOUT DEATH KICKING IN FOR THE HEALTHLESS ENTITY)
            "isHidingHealthbar": unit.isHidingHealthbar,
            "isNotRendered": unit.isNotRendered, // bruh
            "direction": unit.direction,
            "intent": unit.intent, // JUST FOR KILLZONES...?
            "canWalkOntoTheZone": unit.canWalkOntoTheZone, // i mean like ok this too...??
            "destination": unit.destination, // this is, like, a "generic" variable for tiled objects.. but this should be less singular and support multiple params.
            "spawnclass": unit.spawnclass, // uh yeah thisi sjust for spawn zones?? why does every unit have this??
            "properties": unit.properties, // generic immutable dict for properties?
        }
    }

    //////////////
    // Getters //
    ////////////
    static isFlinching(unit) {
        if(unit.effects != undefined) {
            return !!Objdict.find(unit.effects, (effect) => {
                return effect.type == "flinch"
            })
        }
    }
}
// // THIS IS PRETTY OUT OF DATE
// const exampleAction = {
//     "type": String, // "move"|"invoke"|"assist"|"move through"|"invoke skill"
//     "stage": Stage,
//     "performer": Unit,
//     "target": Unit,
//     "position": Point, // position of this action
//     "distance": Number, // shortest orthogonal distance from the starting action.
//     "isStartingAction": Boolean,
//     // THE STATE **BEFORE** THE ACTION IS PERFORMED
//     "alphastage": {
//         "units": [{Unit}, {Unit}, {Unit}],
//         "tiles": [{Tile}, {Tile}, ..., {Tile}],
//     },
//     // THE STATE **AFTER** THE ACTION IS PERFORMED
//     "omegastage": {
//         "units": [{Unit}, {Unit}, {Unit}],
//         "tiles": [{Tile}, {Tile}, ..., {Tile}],
//     },
//     "results": {
//         "target": {
//             "health": -1, // remove one health
//             "position": {"x": -1, "y": 0}, // move left one tile
//         },
//         "peformer": {
//             "health": +1
//         },
//     },
//     "counterAction": Action,
// }

// TODO: hey is it documented anywhere that action.positions are in reverse order, so action.positions[0] is the current position, and action.positions[1] is the last position?

import Delta from "@frog/source/models/Delta.js"

function addStep(action, step) {
    if(step == undefined) return
    if(step instanceof Array == false) {
        step = [step]
    }
    step.forEach((step) => {
        action.omegastage = step.omegastage
        action.steps.push(step)
    })
}

// ACTIONS is a single discrete input that the player/ai has
// chosen. They are legal actions to perform from the current
// state: within range, respecting targets, etc. They include
// a list of steps/beats.

// STEPS/BEATS are the execution of an action, or a script.
// They include there own discrete edit onto the world, with
// all the details necessary to perform it. It includes both
// the state BEFORE and AFTER the step is performed. They can
// be overlapped or combined by the director.

// this takes in action.omegastage and target unitKey, and
// appends steps to the actions if relevant
function checkForTrapsAtUnitPosition(action, unitKey) {
    const target = action.omegastage.units[unitKey]
    const triggers = []
    Objdict.forEach(action.omegastage.units, (trapper) => {
        if(trapper.isDead == true
        || trapper.hasBeenRemoved == true) {
            return
        }
        Objdict.forEach(trapper.effects, (effect, effectKey) => {
            if(effect.type == "trap") {
                const positions = calculateTrapPositions({
                    "stage": action.omegastage,
                    "unit": trapper,
                    "trap": effect
                })
                positions.forEach((position) => {
                    if(Geometry.equals(target.position, position)) {
                        triggers.push({
                            "trapper": trapper,
                            // "position": position,
                            // "actionMark": effect.actionMark,
                            // "skillKey": effect.skillKey,
                            // "effectKey": effectKey,
                            "trap": effect
                        })
                    }
                })
            }
        })
    })
    // TODO: Resolve traps in the order they were thrown!!
    // if(triggers.length > 1) {
    //     triggers.sort((a, b) => a.effect.actionMark - b.effect.actionMark)
    // }
    triggers.forEach((trigger) => {
        if(action.omegastage.units[trigger.trapper.key].isDead == true
        || action.omegastage.units[unitKey].isDead == true) {
            return
        }
        const skill = skills.get(trigger.trap.skillKey)
        if(skill == undefined) {
            return
        }
        if(skill.calculateStep instanceof Function) {
            addStep(action, skill.calculateStep({
                "performerKey": trigger.trapper.key,
                "position": target.position, // TODO: THIS ISN'T RIGHT!!
                "stage": action.omegastage,
                "effectKey": trigger.trap.effectKey,
            }))
        } else {
            // TODO: Deprecate this!!
            addStep(action, Step.instantiate({
                "type": "invoke skill",
                "skillKey": action.skillKey,
                "alphastage": action.omegastage,
                "deltastages": skill.calculateDeltastages({
                    "performerKey": trigger.trapper.key,
                    "position": target.position, // TODO: THIS ISN'T RIGHT!!
                    "stage": action.omegastage,
                    "effectKey": trigger.trap.effectKey,
                }),
            }))
        }

        /////////////
        // DEATHS //
        ///////////
        addStep(action, Reactions.getSteps(action.omegastage))

        // TODO: Can you counter-attack a dangerzone skill?
    })
}
